import { Component, inject, Input } from '@angular/core';
import { ModalRef } from '@siemens/element-ng/modal';

@Component({
    selector: 'app-delete-request',
    templateUrl: './delete-request.component.html',
    styleUrls: ['./delete-request.component.scss'],
    standalone: false
})
export class DeleteRequestComponent {
    @Input() heading = 'Eintrag löschen.';
    @Input() text = 'Wollen Sie den Eintrag wirklich löschen?';

    public modalRef = inject(ModalRef);
}
